import { Component, OnInit } from '@angular/core';
import { DateFilterTypes } from 'app/modules/common/enums/date-filter-enums';
import { OrderSelectionFilter } from 'app/modules/common/enums/actuation-filter-enums';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';
import { FilterService } from 'app/modules/selection-generic/services/filter.service';


@Component({
    selector: 'app-actuation-filter',
    templateUrl: './actuation-filter.component.html',
    styleUrls: ['./actuation-filter.component.scss'],
    standalone: false
})
export class ActuationFilterComponent implements OnInit {

  orderSelectionFilter = OrderSelectionFilter;
  DateFilterType = DateFilterTypes;
  actuationSelection: any;  
  obj42 :any;
  obj41 :any;
  PoblacionList:any=[];
  filteredProvinceList: any[] = [];
  filteredPoblacionList: any[] = [];
  public provinceList: Array<{ value: string; viewValue: string }>;

  
  constructor(public selectionService: SelectionGenericService, public filterServcie: FilterService) { }

  ngOnInit(): void {
    this.actuationSelection = this.selectionService.ActuationSelectionModal;

    this.initializeForm();
    this.getHardCodedList();

    this.selectionService.GetUsuarioList().subscribe(res => {
      if (res.code === 0) {
        this.filterServcie.UsuarioList$ = res.result;
      }
    }, error => {
      console.error(error);
    });

    this.selectionService.GetCoordinatorList().subscribe(res => {
      if (res.code === 0) {
        this.filterServcie.CoordinadorList$ = res.result;
      }
    }, error => {
      console.error(error);
    });

    this.selectionService.GestorList().subscribe(
      (res) => {
          if (res.code === 0) {
              this.filterServcie.GestorList$ = res.result;
          }
      },
      (error) => {
          console.error(error);
      }
  );
  if (this.filterServcie.PoblacionList == undefined){
        this.selectionService.PoblacionList().subscribe(
          (res) => {
            if (res.code === 0) {
              this.filterServcie.PoblacionList = res.result;
              this.filteredPoblacionList = [...this.filterServcie.PoblacionList];
            }
          },
          (error) => {
            console.error(error);
          }
        );
    }else{
      this.filteredPoblacionList = [...this.filterServcie.PoblacionList];
    }

  }

  initializeForm(): void {
    const a = this.selectionService.ActuationSelectionModal;
    const CommonDateFrom = !a.RegistroDateFrom ? null : a.RegistroDateFrom;
    const CommonDateTo = !a.RegistroDateTo ? null : a.RegistroDateTo;
    const FechaRevisionDateFrom = !a.FechaRevisionDateFrom ? null : a.FechaRevisionDateFrom;
    const FechaRevisionDateTo = !a.FechaRevisionDateTo ? null : a.FechaRevisionDateTo;
    const Usuario = !a.Usuario ? null : a.Usuario;
    const Coordinador = !a.Coordinador ? null : a.Coordinador;
    const Revisadas = !a.IsRevisadas ? null : a.IsRevisadas;
    const ConComentarios = !a.IsConComentarios ? null : a.IsConComentarios;
    const ConOrdenes = !a.IsConOrdenes ? null : a.IsConOrdenes;
    const IsConceptosFacturables = !a.IsConceptosFacturables ? null : a.IsConceptosFacturables;
    const FacturacionRadioButton = !a.FacturacionRadioButton ? null : a.FacturacionRadioButton;
    const FacturacionFraCentro = !a.FacturacionFraCentro ? null : a.FacturacionRadioButton;
    const PeriodoDeBajaDateFrom = !a.PeriodoDeBajaDateFrom ? null : a.PeriodoDeBajaDateFrom;
    const PeriodoDeBajaDateTo = !a.PeriodoDeBajaDateTo ? null : a.PeriodoDeBajaDateTo;
    const leaveType = a.LeaveType === '' ? null : a.LeaveType.split(',');
    const Gestor = !a.Gestor ? null : a.Gestor;
    const EmpresaCoordinador = !a.EmpresaCoordinador ? null : a.EmpresaCoordinador;

    this.filterServcie.CommonDateFrom.setValue(CommonDateFrom);
    this.filterServcie.CommonDateTo.setValue(CommonDateTo);
    this.filterServcie.FechaRevisionDateFrom.setValue(FechaRevisionDateFrom);
    this.filterServcie.FechaRevisionDateTo.setValue(FechaRevisionDateTo);
    this.filterServcie.Usuario = Usuario;
    this.filterServcie.Coordinador = Coordinador;
    this.filterServcie.Gestor = Gestor;
    this.filterServcie.EmpresaCoordinador = EmpresaCoordinador;
    this.filterServcie.Revisadas = Revisadas;
    this.filterServcie.ConComentarios = ConComentarios;
    this.filterServcie.ConOrdenes = ConOrdenes;
    this.filterServcie.IsConceptosFacturables = IsConceptosFacturables;
    this.filterServcie.FacturacionRadioButton = FacturacionRadioButton;
    this.filterServcie.FacturacionFraCentro = FacturacionFraCentro;
    this.filterServcie.PeriodoDeBajaDateTo.setValue(PeriodoDeBajaDateTo);
    this.filterServcie.PeriodoDeBajaDateFrom.setValue(PeriodoDeBajaDateFrom);
    this.filterServcie.ActuationLeaveType.setValue(leaveType);
  }


    filtrarProvincias(event: Event): void {
      const busqueda = (event.target as HTMLInputElement).value.toLowerCase();
      this.filteredProvinceList = this.provinceList.filter(prov => 
        prov.viewValue.toLowerCase().includes(busqueda)
      );
    }

    filtrarPoblaciones(event: Event): void {
      const busqueda = (event.target as HTMLInputElement).value.toLowerCase();
      this.filteredPoblacionList = this.filterServcie.PoblacionList.filter((pob: string) => 
        pob.toLowerCase().includes(busqueda) 
      );
    }

  getHardCodedList(): void {
        this.provinceList = [
            { value: 'ALAVA', viewValue: 'ALAVA' },
            { value: 'ALBACETE', viewValue: 'ALBACETE' },
            { value: 'ALICANTE', viewValue: 'ALICANTE' },
            { value: 'ALMERIA', viewValue: 'ALMERIA' },
            { value: 'ANDORRA', viewValue: 'ANDORRA' },
            { value: 'ASTURIAS', viewValue: 'ASTURIAS' },
            { value: 'AVILA', viewValue: 'AVILA' },
            { value: 'BADAJOZ', viewValue: 'BADAJOZ' },
            { value: 'BALEARES', viewValue: 'BALEARES' },
            { value: 'BARCELONA', viewValue: 'BARCELONA' },
            { value: 'BURGOS', viewValue: 'BURGOS' },
            { value: 'CACERES', viewValue: 'CACERES' },
            { value: 'CADIZ', viewValue: 'CADIZ' },
            { value: 'CANTABRIA', viewValue: 'CANTABRIA' },
            { value: 'CASTELLON', viewValue: 'CASTELLON' },
            { value: 'CEUTA', viewValue: 'CEUTA' },
            { value: 'CIUDAD REAL', viewValue: 'CIUDAD REAL' },
            { value: 'CORDOBA', viewValue: 'CORDOBA' },
            { value: 'CUENCA', viewValue: 'CUENCA' },
            { value: 'GIRONA', viewValue: 'GIRONA' },
            { value: 'GRANADA', viewValue: 'GRANADA' },
            { value: 'GUADALAJARA', viewValue: 'GUADALAJARA' },
            { value: 'GUIPUZCOA', viewValue: 'GUIPUZCOA' },
            { value: 'HUELVA', viewValue: 'HUELVA' },
            { value: 'HUESCA', viewValue: 'HUESCA' },
            { value: 'JAEN', viewValue: 'JAEN' },
            { value: 'LA CORUÑA', viewValue: 'LA CORUÑA' },
            { value: 'LAS RIOJA', viewValue: 'LAS RIOJA' },
            { value: 'LAS PALMAS', viewValue: 'LAS PALMAS' },
            { value: 'LEON', viewValue: 'LEON' },
            { value: 'LLEIDA', viewValue: 'LLEIDA' },
            { value: 'LUGO', viewValue: 'LUGO' },
            { value: 'MADRID', viewValue: 'MADRID' },
            { value: 'MALAGA', viewValue: 'MALAGA' },
            { value: 'MELILLA', viewValue: 'MELILLA' },
            { value: 'MURCIA', viewValue: 'MURCIA' },
            { value: 'NAVARRA', viewValue: 'NAVARRA' },
            { value: 'ORENSE', viewValue: 'ORENSE' },
            { value: 'PALENCIA', viewValue: 'PALENCIA' },
            { value: 'PONTEVEDRA', viewValue: 'PONTEVEDRA' },
            { value: 'SALAMANCA', viewValue: 'SALAMANCA' },
            {
                value: 'SANTA CRUZ DE TENERIFE',
                viewValue: 'SANTA CRUZ DE TENERIFE',
            },
            { value: 'SEGOVIA', viewValue: 'SEGOVIA' },
            { value: 'SEVILLA', viewValue: 'SEVILLA' },
            { value: 'SORIA', viewValue: 'SORIA' },
            { value: 'TARRAGONA', viewValue: 'TARRAGONA' },
            { value: 'TERUEL', viewValue: 'TERUEL' },
            { value: 'TOLEDO', viewValue: 'TOLEDO' },
            { value: 'VALENCIA', viewValue: 'VALENCIA' },
            { value: 'VALLADOLID', viewValue: 'VALLADOLID' },
            { value: 'VIZCAYA', viewValue: 'VIZCAYA' },
            { value: 'ZAMORA', viewValue: 'ZAMORA' },
            { value: 'ZARAGOZA', viewValue: 'ZARAGOZA' },
        ];

        this.filteredProvinceList = [...this.provinceList];
    }

    onProvinciaChange(valorProvincia: string): void {
    if (valorProvincia) {
      this.actuationSelection.Poblacion = '';
    }
    this.actuationSelection.Provincia = valorProvincia;
  }

  onPoblacionChange(valorPoblacion: any): void {
    if (valorPoblacion) {
      this.actuationSelection.Provincia = '';
    }
    this.actuationSelection.Poblacion = valorPoblacion;
  }


  public SetFilterValues(filterType: string, data: Date = null): void {

    switch (filterType) {
      case 'commonDateFrom':
        this.actuationSelection.RegistroDateFrom = DateHelper.getUTCDateString(data);
        break;

      case 'commonDateTo':
        this.actuationSelection.RegistroDateTo = DateHelper.getUTCDateString(data);
        break;
      case 'FechaRevisionDateFrom':
        this.actuationSelection.FechaRevisionDateFrom = DateHelper.getUTCDateString(data);
        break;

      case 'FechaRevisionDateTo':
        this.actuationSelection.FechaRevisionDateTo = DateHelper.getUTCDateString(data);
        break;
      case 'Usuario':
        this.actuationSelection.Usuario = this.filterServcie.Usuario;
        break;    
      case 'Coordinador':
        this.actuationSelection.Coordinador = this.filterServcie.Coordinador;
        break;
      case 'Revisadas':
        this.actuationSelection.IsRevisadas = this.filterServcie.Revisadas;
        break;
      case 'ConComentarios':
        this.actuationSelection.IsConComentarios = this.filterServcie.ConComentarios;
        break;
      case 'ConOrdenes':
        this.actuationSelection.IsConOrdenes = this.filterServcie.ConOrdenes;
        break;
      case 'FacturacionRadioButton':
        this.actuationSelection.FacturacionRadioButton = this.filterServcie.FacturacionRadioButton;
        break;
      case 'ConceptosFacturables':
        this.actuationSelection.IsConceptosFacturables = this.filterServcie.IsConceptosFacturables;
        break;
      case 'FacturacionFraCentro':
        this.actuationSelection.FacturacionFraCentro = this.filterServcie.FacturacionFraCentro;
        break;
      case 'PeriodoDeBajaDateFrom':
        this.actuationSelection.PeriodoDeBajaDateFrom = DateHelper.getUTCDateString(data);
        break;
      case 'PeriodoDeBajaDateTo':
        this.actuationSelection.PeriodoDeBajaDateTo = DateHelper.getUTCDateString(data);
        break;
      case 'EmpresaCoordinador':
          this.actuationSelection.EmpresaCoordinador = this.filterServcie.EmpresaCoordinador;
          break;
      case 'Gestor':
            this.actuationSelection.Gestor = this.filterServcie.Gestor;
            break;
      default:
        break;
    }
  }

  public setSelectedActivityType(actionTypeNode: any, isSelected: boolean): void {
    const ActivityTypes = this.selectionService.ActuationSelectionModal.ActivityTypes;
    if (isSelected) {
      if (ActivityTypes.filter(x => x.id === actionTypeNode.original.id).length === 0) {
        this.selectionService.ActuationSelectionModal.ActivityTypes = ActivityTypes.concat(actionTypeNode.original);
      }
    }else {

      //Handle visitas selcetion - (Efectivas & Ausentes)
      const objWithIdIndexSearch = this.selectionService.ActuationSelectionModal.ActivityTypes.findIndex((obj) => obj.text === "Visitas");
      if(objWithIdIndexSearch>=0 && (actionTypeNode.original.id==41 || actionTypeNode.original.id==42))
      {
        const masterList= this.selectionService.ActivityList;
        if(actionTypeNode.original.id==41)
        {
          this.obj42 = this.getObjectFromMasterList(42);
          this.selectionService.ActuationSelectionModal.ActivityTypes = ActivityTypes.concat(this.obj42);
          this.selectionService.ActuationSelectionModal.ActivityTypes.splice(objWithIdIndexSearch, 1);

        }else if(actionTypeNode.original.id==42){
          this.obj41 = this.getObjectFromMasterList(41);;
          this.selectionService.ActuationSelectionModal.ActivityTypes = ActivityTypes.concat(this.obj41);
          this.selectionService.ActuationSelectionModal.ActivityTypes.splice(objWithIdIndexSearch, 1);
        }
      }else
      {
        const objWithIdIndex = this.selectionService.ActuationSelectionModal.ActivityTypes.findIndex((obj) => obj.text === actionTypeNode.text);
        this.selectionService.ActuationSelectionModal.ActivityTypes.splice(objWithIdIndex, 1);
      }
    }
  }

  getObjectFromMasterList(id)
  {
    const masterList= this.selectionService.ActivityList;
    return masterList.filter((obj) => obj.id === 42);
  }

  SetAttribute(attributeList: any[]): void {
    this.actuationSelection.AttributeList = attributeList;
  }

  SetAttributeModal(attributeModal: any[]): void {
    this.filterServcie.ActuationSelectedAttribute = attributeModal;
  }

  SetLeaveType(leaveTypeArray: any[]): void {
    let leaveTypes = '';
    if (leaveTypeArray !== null) {
      leaveTypeArray.forEach(leaveType => {
        leaveTypes += leaveType + ',';
      });
    }

    this.actuationSelection.LeaveType = leaveTypes.replace(/,\s*$/, '');
  }

}
